export default __webpack_public_path__ + "navigation-examples-route-deserialize-thumbnail-v1-960-11c7d6d3829e4e3dd1df048d96a2a978.png";